import guest from '@/middleware/modules/guest'

const Login = () => import(/* webpackChunkName: "_v-auth" */ '@/views/auth/Login.vue')
const Register = () => import(/* webpackChunkName: "_v-auth" */ '@/views/auth/Register.vue')
const PasswordRecover = () => import(/* webpackChunkName: "_v-auth" */ '@/views/auth/PasswordRecover.vue')
const PasswordReset = () => import(/* webpackChunkName: "_v-auth" */ '@/views/auth/PasswordReset.vue')
const PasswordSet = () => import(/* webpackChunkName: "_v-auth" */ '@/views/auth/PasswordSet.vue')
const VerifyEmail = () => import(/* webpackChunkName: "_v-auth" */ '@/views/auth/VerifyEmail.vue')

export default [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      layout: 'auth-layout',
      middleware: [guest],
    },
  },
  // {
  //   path: '/register',
  //   name: 'register',
  //   component: Register,
  //   meta: {
  //     layout: 'auth-layout',
  //     middleware: [guest],
  //   },
  // },
  {
    path: '/password/reset',
    name: 'password-reset',
    component: PasswordRecover,
    meta: {
      layout: 'auth-layout',
      middleware: [guest],
    },
  },
  {
    path: '/password/reset/:token([a-zA-Z0-9]{64})',
    name: 'password-request',
    component: PasswordReset,
    meta: {
      layout: 'auth-layout',
      middleware: [guest],
    },
  },
  {
    path: '/email/verify/:token([a-zA-Z0-9]{60})',
    name: 'verify-email',
    component: VerifyEmail,
    meta: {
      layout: 'auth-layout',
      middleware: [guest],
    },
  },
  {
    path: '/password/set/:token([a-zA-Z0-9]{60})',
    name: 'password-set',
    component: PasswordSet,
    meta: {
      layout: 'auth-layout',
      middleware: [guest],
    },
  },
]
